import React from 'react';
import Dotdotdot from "react-dotdotdot";
import _ from "lodash";
import {cropText} from "../../../libs/helper";

class DraftContentExcerpt extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            excerpt: "",
        };
        this.maxLength = parseInt(this.props.maxLength);
    }

    componentDidMount() {
        if(this.props.contentRaw && _.get(this.props,"contentRaw.blocks")){
            let newExcerpt = "";
            let block = _.get(this.props,"contentRaw.blocks") || []
            block.forEach((item)=>{
                if(item.text !== "attachment" && item.text !== "📷"){
                    newExcerpt = newExcerpt + item.text;
                }
            });

            if(this.maxLength > 0){
                newExcerpt = cropText(newExcerpt, this.maxLength);
            }
            this.setState({excerpt: newExcerpt});
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.contentRaw !== this.props.contentRaw){
            let newExcerpt = "";
            let block = _.get(this.props,"contentRaw.blocks") || []
            block.forEach((item)=>{
                if(item.text !== "attachment" && item.text !== "📷"){
                    newExcerpt = newExcerpt + item.text;
                }
            });
            if(this.maxLength > 0){
                newExcerpt = cropText(newExcerpt, this.maxLength);
            }
            this.setState({excerpt: newExcerpt});
        }
    }

    render(){
        return(
            <div className={`excerpt ${this.props.showQuote && this.state.excerpt.length > 1 ? "quote" : ""}`}>
                <Dotdotdot clamp={this.props.maxLine} useNativeClamp={false}>
                    {this.state.excerpt}
                </Dotdotdot>
            </div>
        )
    }
}

export default DraftContentExcerpt;